import type { Material, SceneControl } from '@anov/3d-core'
import { Clock, Color, Mesh, NormalBlending, PlaneGeometry, ShaderMaterial, use } from '@anov/3d-core'
import type { ParticleOption } from '../types'
import CircleShader from '../shader/circle'
import ParticleMesh from '.'

class SingleCircleMesh extends ParticleMesh {
  private _material: ShaderMaterial
  private _radius: number
  private _color: string

  public get radius(): number {
    return this._radius
  }

  public get color(): string {
    return this._color
  }

  public set color(newValue: string) {
    if (this._color === newValue)
      return
    this._color = newValue
    this._material.uniforms.color.value = new Color(this._color)
  }

  constructor(option: ParticleOption = {}, sceneControl: SceneControl) {
    super(sceneControl)
    const { radius = 0.25, color = '0xFFFFFF', visible = true } = option
    this._radius = radius
    this._color = color
    this.visible = visible
    this.init()
  }

  private async init() {
    const { uniforms: defaultUniforms, vertexShader, fragmentShader } = CircleShader
    const uniforms = structuredClone(defaultUniforms)
    uniforms.color.value = new Color(this.color)
    this._material = new ShaderMaterial({
      uniforms,
      vertexShader,
      fragmentShader,
      side: 2,
      transparent: true,
      depthWrite: true,
      depthTest: true,
      // blending: NormalBlending, // 明确混合模式
      polygonOffset: false, // 解决深度冲突
      polygonOffsetFactor: -1,
    })

    this._mesh = new Mesh(new PlaneGeometry(this.radius * 2, this.radius * 2), this._material)
    this._mesh.rotation.x = Math.PI / 2

    this.add(this._mesh)

    const clock = new Clock()
    use.useframe(this.sceneControl, () => {
      this._material.uniforms.iTime.value = clock.getElapsedTime() * 0.5
    })
  }
}

export default SingleCircleMesh
